<template lang="html">
  <v-layout column>
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      </v-toolbar-items>
    </v-toolbar>

    <v-card>
      <v-card-title primary-title>
        <h2>{{ $t('DASHBOARD_BT_MYDASH') }}</h2>
      </v-card-title>
      <v-card-text>

  <v-container fluid grid-list-md>
<!-- <pre> -->
    <template v-for="(item,id1) in items">
      <!-- {{ item | json }} -->
      <v-layout :key="id1" row wrap v-if="item.type == 'row'">

        <template v-for="(child,id2) in item.children">
          <!-- {{ child | json }} -->
          <v-flex :key="id2" d-flex v-if="child.type == 'col'" :class="child.sizes">

            <!-- <template v-for="item2 in child.content"> -->
              <!-- {{ child.content | json }} -->
              <v-layout row wrap v-if="child.content.type == 'row'">

                <template v-for="(child2,id3) in child.content.children">
                  <!-- {{ child2 | json }} -->
                  <v-flex :key="id3" d-flex v-if="child2.type == 'col'" :class="child2.sizes">

                    <!-- <template v-for="item2 in child.content"> -->
                      <!-- {{ child.content | json }} -->
<!-- // NO MORE ROWS HERE
                      <v-layout row wrap v-if="child.content.type == 'row'">

                        <template v-for="child2 in child.content.children">
                          < !-- {{ child2 | json }} -- >
                          <v-flex d-flex v-if="child2.type == 'col'" :class="child2.sizes">
                          </v-flex>
                        </template>

                      </v-layout>
-->
                      <v-card :color="child2.content.background" v-if="child2.content.type == 'card'" :class="'theme--' + child2.content.theme">
                        <!-- <v-card-title primary class="title">Lorem</v-card-title> -->
                        <v-card-text v-html="child2.content.html || child2.content.text"></v-card-text>
                      </v-card>
                      <v-card :color="child2.content.background" v-if="child2.content.type == 'iframe'" :class="'theme--' + child2.content.theme">
                        <iframe :src="child2.content.src" width="100%" height="100%"></iframe>
                      </v-card>
                    <!-- </template> -->

                  </v-flex>
                </template>

              </v-layout>
              <v-card :color="child.content.background" v-if="child.content.type == 'card'" :class="'theme--' + child.content.theme">
                <!-- <v-card-title primary class="title">Lorem</v-card-title> -->
                <v-card-text v-html="child.content.html || child.content.text"></v-card-text>
              </v-card>
              <v-card :color="child.content.background" v-if="child.content.type == 'iframe'" :class="'theme--' + child.content.theme">
                <iframe :src="child.content.src" width="100%" height="100%"></iframe>
              </v-card>
            <!-- </template> -->

          </v-flex>
        </template>

      </v-layout>
    </template>
<!-- </pre> -->
  </v-container>

        <!-- -->
  <v-card v-if="showChart">
    <v-card-text>
      <v-card-title> {{$t('REPORTING_SAVED_DEMO_TITLE')}} </v-card-title>
      <PieChart  :key="componentKey" :chartData="chartData" :options="options" />
    </v-card-text>
  </v-card>
        <!-- -->
  

  <!-- <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md4>
        <v-card color="#fafab2">
          < !-- <v-card-title primary class="title">Lorem</v-card-title> -- >
          <v-card-text>Willkommen zum FairMate CRM 3.0<br /><a href="https://www.fairmate.de">https://www.fairmate.de</a></v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-card color="indigo" dark>
              <v-card-text>{{ lorem.slice(0, 70) }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            v-for="n in 2"
            :key="n"
            d-flex
            xs12
          >
            <v-card
              color="red lighten-2"
              dark
            >
              <v-card-text>{{ lorem.slice(0, 40) }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12 sm6 md2 child-flex>
        <v-card color="green lighten-2" dark>
          <iframe src="https://picsum.photos/640/360"></iframe>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-card color="blue lighten-2" dark>
          <iframe src="http://localhost:8080"></iframe>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container> -->

      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script lang="js">

import PieChart from '../components/PieChart'
import {mapGetters} from 'vuex'

export default  {
  name: 'Dashboard',
  props: ['refToolbar'],
  components: {
    PieChart
  },

  data() {

    return {
      showChart: false,
      componentKey: 0,
      chartData: {},
      options: {},
      labels: [],
      dataset: ['0'], 
      items: require('../assets/dashboard.json'),
      lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`

    }
  },

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.labels = [this.$t('NO_DATA')]
    // this.fillData()
  },

  computed: {
    ...mapGetters(['mStatistics', 'countries']) 
  },

  methods: {
    fillData() {
      this.labels = this.mStatistics.rows.map(m => m.group)
      this.labels = this.labels.map(a => this.countries.find(b => b.iso_code == a).label);
      const dataset = this.mStatistics.rows.map(m => parseInt(m.count))
      var coloR = [];

      var dynamicColors = function() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgb(" + r + "," + g + "," + b + ")";
      };

      this.mStatistics.rows.forEach(() => {
        coloR.push(dynamicColors());
      })


      this.chartData = {
        labels: this.labels,
        datasets: [
          {
            label: 'Newsletter 1',
            backgroundColor: coloR,
            data: dataset
          }
        ]
      }
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'left'
        },
        annotation: {
          annotations: [{
            drawTime: 'afterDatasetsDraw',
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: this.avg,
            borderColor: 'rgba(241, 160, 160, 0.87)',
            borderWidth: 4,
            label: {
              enabled: true,
              position: "center",
              xAdjust: 0,
              content: 'Annotation Label content'
            }
          }]
        }
      }
      this.forceReRender();
    },

    forceReRender() {
      this.componentKey += 1;
    },
  },
  
  beforeDestroy() {
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style scoped lang="scss">
.v-card {
  word-break: break-word;
}
iframe {
  border: none;
}
</style>
